module.exports = __webpack_public_path__ + "img/select06.114ddd5e.png";